<template>
  <div class="login">
    <div align="center">
<!--      <div class="logo-text" style="margin-bottom: 3px"><span>管理学习与经验分享</span></div>-->
      <img  class="logo-52" src="/book/52-04.png">
    </div>
    <a-form id="components-form-demo-normal-login" :form="form"
            class="login-form" @submit="handleSubmit">
      <a-form-item>
        <a-input id="userId" v-decorator="['userId',
          {initialValue: userId, rules: [{ required: true, message: '请输入账号!' }] }
        ]" placeholder="账号">
          <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)"/>
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-input id="password" v-decorator="['password',
          {initialValue: password, rules: [{ required: true, message: '请输入密码!' }] }
        ]" type="password" placeholder="密码">
          <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)"/>
        </a-input>
      </a-form-item>
      <a-form-item class="login-button">
        <!--<a-checkbox v-decorator="['rememberMe',{valuePropName: 'checked',initialValue: true,}]">-->
          <!--记住我-->
        <!--</a-checkbox>-->
<!--        <a class="login-form-forgot" href="">-->
<!--          Forgot password-->
<!--        </a>-->
        <a-button type="primary" html-type="submit" class="login-form-button">
          登录
        </a-button>
<!--        Or <a href="">register now!</a>-->
      </a-form-item>
    </a-form>
    <div align="center" class="about">
      <span v-if="isMobile()">
        <a> <router-link v-bind:to="{name: 'about'}">关于我们</router-link></a></span>
      <span v-if="!isMobile()">
        <a> <router-link v-bind:to="{name: 'about-pc'}">关于我们</router-link></a></span>
    </div>
    <div align="center" class="login-footer">
      <span><a href="https://beian.miit.gov.cn/" target="_blank" style="color:rgba(0, 0, 0, 0.65)">沪ICP备19027057号</a></span>
    </div>
  </div>
</template>

<script>
import qs from 'qs';
import store from '../store';
// eslint-disable-next-line import/no-cycle
import service from '../axios/reponse';
import {getItemWithExpiry, setItemWithExpiry} from "../js/common";

export default {
  name: 'Login',
  store,
  metaInfo() {
    return {
      title: this.title,
      meta: [
        { vmid: 'description', name: 'description', content: '在52微课堂一起交流学习心得.' },
      ],
    };
  },
  data() {
    return {
      userId: '',
      password: '',
      title: '',
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.setTitle();
  },
  mounted() {
    this.initForm();
    this.isLogin();
  },
  methods: {
    async handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          const data = await service({
            method: 'post',
            url: '/service/login/form',
            data: qs.stringify(values),
          });
          if (data.code === 0) {
            store.state.user.userId = data.data.userId;
            store.state.user.name = data.data.name;
            store.state.user.roles = data.data.roles;
            if (window.localStorage) {
              setItemWithExpiry('userInfo', JSON.stringify(data.data), 1800000);
            }
            if (data.data.firstTimeLogin === true) {
              this.$message.warning('首次登录,请修改密码');
              this.$router.push('/reset/password');
            } else {
              this.$message.success('登录成功', 1);
              // if (values.rememberMe) {
              //   this.setCookie('userId', values.userId, 7); // 保存帐号到cookie，有效期7天
              //   this.setCookie('password', values.password, 7); // 保存密码到cookie，有效期7天
              // } else {
              //   this.delCookie('userId');
              //   this.delCookie('password');
              // }
              const uncommentFeedbacks = await service({
                method: 'GET',
                url: '/service/uncomment/myfeedbacks',
              });
              console.log(uncommentFeedbacks);
              if (uncommentFeedbacks.count > 0) {
                store.state.uncommentFeedbacks = uncommentFeedbacks.data;
                this.$router.push('/layout/homework');
              } else {
                this.$router.push('/layout/book-card');
              }
            }
          } else if (data.msg === 'NEED_CHANGE_PASSWORD') {
            store.state.user.userId = values.userId;
            store.state.user.password = values.password;
            this.$router.push('/reset/password');
          } else {
            this.$message.error('用户名或密码错误');
          }
        } else {
          this.form.resetFields(['password']);
        }
      });
    },


    initForm() {
      // if (this.getCookie('userId') !==
      // 'null' && this.getCookie('password')
      // !== 'null' && this.getCookie('userId') !== null && this.getCookie('password') !== null) {
      //   this.userId = this.getCookie('userId') === null ? '' : this.getCookie('userId');
      //   this.password = this.getCookie('password') === null ? '' : this.getCookie('password');
      // }
      // oRemember.checked = true;
    },
    setCookie(name, value, day) {
      // eslint-disable-next-line no-param-reassign
      value = window.btoa(value);
      const date = new Date();
      date.setDate(date.getDate() + day);
      document.cookie = `${name}=${value};expires=${date}`;
    },
    getCookie(name) {
      const reg = RegExp(`${name}=([^;]+)`);
      const arr = document.cookie.match(reg);
      if (arr) {
        return window.atob(arr[1]);
        // return arr[1];
      }
      return '';
    },
    delCookie(name) {
      this.setCookie(name, null, -1);
    },
    async isLogin() {
      if (window.localStorage) {
        let userInfo = getItemWithExpiry('userInfo');
        if ( userInfo !== null && userInfo !== '') {
          userInfo = JSON.parse(userInfo);
          store.state.user.userId = userInfo.userId;
          store.state.user.name = userInfo.name;
          store.state.user.roles = userInfo.roles;
        }
      }
      // eslint-disable-next-line valid-typeof
      if (typeof store.state.user.userId === 'undefined' || store.state.user.userId === null) {
        return;
      }
      const uncommentFeedbacks = await service({
        method: 'GET',
        url: '/service/uncomment/myfeedbacks',
      });
      console.log(uncommentFeedbacks);
      if (uncommentFeedbacks.count > 0) {
        store.state.uncommentFeedbacks = uncommentFeedbacks.data;
        this.$router.push('/layout/homework');
      } else {
        this.$router.push('/layout/book-card');
      }
    },
    setTitle() {
      this.title = '管理学习与经验分享';
    },
  },
};
</script>

<style scoped>
  .login{
    margin-left: auto;
    margin-right: auto;
    max-width: 300px;
    position: relative;
    top: 150px;
  }
  #components-form-demo-normal-login .login-form {
    max-width: 300px;
  }
  #components-form-demo-normal-login .login-form-forgot {
    float: right;
  }
  #components-form-demo-normal-login .login-form-button {
    width: 100%;
  }
  .login-button{
    margin-top: -20px;
  }
  .logo-52 {
    margin-bottom: 30px;
    width: 180px;
    height: auto;
  }
  .login-footer{
    position: relative;
    margin-top: 20px;
  }
  .about{
    position: relative;
    margin-top: 100px;
  }
  /*.about span{*/
  /*  color: #1890ff;*/
  /*}*/
  .login-footer span {
    color: #858585;
  }
  /*.logo-text{*/
  /*  position: relative;*/
  /*  color: #858585;*/
  /*  font-size: 20px;*/
  /*  font-weight: 600;*/
  /*}*/
  /*.login-text span{*/
  /*  color: #b90b14;*/
  /*}*/
</style>
